//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
export default {
  name: "SelectCity",
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    value: {
      type: String,
    },
  },
  data() {
    return {};
  },
  watch: {
    // show(cur) {
    //   console.log(cur);
    //   if(cur) {
    //     this.$refs.picker && this.$refs.picker.setValues([this.value])
    //   }
    // }
  },
  computed: {
    ...mapState(["permission"]),
    regionList() {
      const name = this.$route.name;
      if (name === "Operate" || name === "Boss") {
        return this.permission.region;
      } else {
        let arr = [];
        this.permission.shop.forEach((v) => {
          const index = arr.findIndex((item) => item.text === v.region);
          if (index === -1) {
            arr.push({ text: v.region, children: [{ text: v.shop }] });
          } else {
            if (!arr[index].children.some((item) => item.text === v.shop)) {
              arr[index].children.push({ text: v.shop });
            }
          }
        });
        return arr;
      }
    },
  },
  methods: {
    onConfirm(e) {
      let region = {};
      if (typeof e === "string") {
        region = this.columns.find((v) => v.name === e);
      } else {
        region = { region: e[0], name: e[1], shop: e[1] };
      }
      this.$emit("confirm", region);
    },
    onCancel(e) {
      this.$emit("update:show", false);
    },
  },
};
